// extracted by mini-css-extract-plugin
export default {"container":"styles_container__SZ0mC","wrapper":"styles_wrapper__tuyuD"};